export const renderCurrency = (amount = 0, currency = "NGN") => {
    return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: currency,
        currencyDisplay: "narrowSymbol",
    }).format(parseFloat(amount.toString()) || 0);
};